import React, { useState } from 'react';
import { Stack, Autocomplete, Button, Modal, TextField, Select, InputLabel, MenuItem, Box, useMediaQuery } from '@mui/material';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { NumericFormat } from 'react-number-format';
import dayjs from 'dayjs';
import { MobileDateTimePicker, viVN } from '@mui/x-date-pickers';

const AddPaymentModal = ({ onAddPayment, handleClose, order, open }) => {
    const [time, setTime] = useState(null);
    const [note, setNote] = useState('');
    const [amount, setAmount] = useState(0);
    const [type, setType] = useState(1);
    const [method, setMethod] = useState(2);

    const isMobile = useMediaQuery('(max-width:600px)');

    const onAdd = () => {
        onAddPayment({
            lead_order: order.id,
            payment_date: dayjs(time).format(),
            amount: amount,
            note: note,
            payment_type: type,
            payment_method: method,
        });
    };

    const onClose = () => {
        if (handleClose) {
            handleClose();
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isMobile ? '90%' : 400,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                }}
            >
                <Stack spacing={2}>
                    <h4 style={{ textAlign: 'center' }}>Thông tin thanh toán</h4>
                    <Stack spacing={1}>
                        <InputLabel id="type-select-label">Loại thanh toán</InputLabel>
                        <Select
                            labelId="type-select-label"
                            id="type-select-select"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                        >
                            {types.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Stack>
                    <Stack spacing={1}>
                        <InputLabel id="method-select-label">Hình thức thanh toán</InputLabel>
                        <Select
                            labelId="method-select-label"
                            id="method-select-select"
                            value={method}
                            onChange={(e) => setMethod(e.target.value)}
                        >
                            {methods.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Stack>
                    <NumericFormat
                        customInput={TextField}
                        label="Số tiền thanh toán"
                        thousandSeparator="."
                        decimalSeparator=","
                        type="text"
                        suffix="đ"
                        max={order ? order.price : 100000000}
                        variant="standard"
                        placeholder="Số tiền thanh toán"
                        value={amount}
                        onValueChange={(values) => setAmount(parseFloat(values.value))}
                        fullWidth
                    />
                    <TextField
                        label="Ghi chú"
                        fullWidth
                        multiline
                        rows={3}
                        variant="standard"
                        placeholder="Ghi chú"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                    />
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        localeText={viVN.components.MuiLocalizationProvider.defaultProps.localeText}
                        adapterLocale="vi"
                    >
                        <DemoContainer components={['MobileDateTimePicker']}>
                            <DemoItem label="Thời gian thanh toán">
                                <MobileDateTimePicker
                                    value={time}
                                    onChange={(value) => setTime(value)}
                                    format="HH:mm DD/MM/YYYY"
                                    label="Thời gian thanh toán"
                                />
                            </DemoItem>
                        </DemoContainer>
                    </LocalizationProvider>
                    <Stack
                        flexDirection="row"
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                        sx={{ mt: 3 }}
                    >
                        <Button onClick={handleClose} color="warning" fullWidth>
                            Huỷ
                        </Button>
                        <Button
                            disabled={amount === 0 || !time || !type || !method}
                            onClick={onAdd}
                            color="success"
                            fullWidth
                        >
                            Thêm thanh toán
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};

export default AddPaymentModal;

const methods = [
    { name: 'Ví Anhdior', id: 1 },
    { name: 'Tiền mặt', id: 2 },
    { name: 'Chuyển khoản', id: 5 },
    { name: 'Quẹt thẻ', id: 6 },
];

const types = [
    { name: 'Thanh toán toàn bộ', id: 1 },
    { name: 'Đặt cọc', id: 2 },
    { name: 'Thanh toàn còn lại', id: 3 },
    { name: 'Thanh toán thêm một phần', id: 4 },
    { name: 'Hoàn tiền', id: 5 },
];